import React, { createContext, PropsWithChildren, useState } from "react";

type IssueSourceState = {
  issueSource: string;
  issueSources: string[];
};

type IssueResolutionState = {
  issueResolution: string;
  issueResolutions: string[];
};

interface IErrorIssueContext {
  errorIssueSource: string;
  errorIssueResolution: string;
}

interface IErrorIssueActionContext {
  setErrorIssueSource: React.Dispatch<React.SetStateAction<string>>;
  setErrorIssueResolution: React.Dispatch<React.SetStateAction<string>>;
}

interface ICloseCaseTicketContext {
  resolution: IssueResolutionState;
  source: IssueSourceState;
  comment?: string;
  isFormModified?: boolean;
}
interface ICloseCaseTicketActionContext {
  setResolution: React.Dispatch<React.SetStateAction<IssueResolutionState>>;
  setSource: React.Dispatch<React.SetStateAction<IssueSourceState>>;
  setComment: React.Dispatch<React.SetStateAction<string>>;
  setIsFormModified: React.Dispatch<React.SetStateAction<boolean>>;
  restoreInitialState: () => void;
}

const defaultContext = {
  resolution: {
    issueResolution: "",
    issueResolutions: [],
  },
  source: {
    issueSource: "",
    issueSources: [],
  },
  comment: "",
  isFormModified: false,
};

const defaultErrorContext = {
  errorIssueSource: "",
  errorIssueResolution: "",
};

const defaultErrorActionContext = {
  setErrorIssueSource: () => {},
  setErrorIssueResolution: () => {},
};

const defaultActionContext = {
  setResolution: () => {},
  setSource: () => {},
  setComment: () => {},
  setIsFormModified: () => {},
  restoreInitialState: () => {},
};
export const CloseCaseTicketContext =
  createContext<ICloseCaseTicketContext>(defaultContext);

export const CloseCaseTicketActionContext =
  createContext<ICloseCaseTicketActionContext>(defaultActionContext);

export const ErrorIssueContext =
  createContext<IErrorIssueContext>(defaultErrorContext);

export const ErrorIssueActionContext = createContext<IErrorIssueActionContext>(
  defaultErrorActionContext
);

export const CloseCaseTicketProvider = (props: PropsWithChildren<{}>) => {
  const { children } = props;
  const [resolution, setResolution] = useState<IssueResolutionState>({
    issueResolution: "",
    issueResolutions: [],
  });
  const [source, setSource] = useState<IssueSourceState>({
    issueSource: "",
    issueSources: [],
  });

  const [comment, setComment] = useState<string>("");
  const [errorIssueResolution, setErrorIssueResolution] = useState<string>("");
  const [errorIssueSource, setErrorIssueSource] = useState<string>("");
  const [isFormModified, setIsFormModified] = useState<boolean>(false);

  const restoreInitialState = () => {
    setResolution({ issueResolution: "", issueResolutions: [] });
    setSource({ issueSource: "", issueSources: [] });
    setComment("");
    setIsFormModified(false);
  };

  return (
    <CloseCaseTicketContext.Provider
      value={{ resolution, source, comment, isFormModified }}
    >
      <CloseCaseTicketActionContext.Provider
        value={{
          setResolution,
          setSource,
          setComment,
          setIsFormModified,
          restoreInitialState,
        }}
      >
        <ErrorIssueContext.Provider
          value={{ errorIssueResolution, errorIssueSource }}
        >
          <ErrorIssueActionContext.Provider
            value={{ setErrorIssueResolution, setErrorIssueSource }}
          >
            {children}
          </ErrorIssueActionContext.Provider>
        </ErrorIssueContext.Provider>
      </CloseCaseTicketActionContext.Provider>
    </CloseCaseTicketContext.Provider>
  );
};
